import { createRouter, createWebHashHistory } from "vue-router";
import { myStore } from "@/store/index.js";

const store = myStore();

import Index from "@/views/Index.vue";

const routes = [
  {
    path: `/`,
    name: "Index",
    meta: {
      title: "",
    },
    component: Index,
  },
  {
    path: `/record`,
    name: "Record",
    meta: {
      title: "预约记录",
    },
    component: () => import("@/views/Record.vue"),
  },
  {
    path: `/my`,
    name: "My",
    meta: {
      title: "",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "@/views/My.vue"),
  },
  {
    path: `/yuyue`,
    name: "Yuyue",
    meta: {
      title: "旧衣回收",
    },
    component: () => import("@/views/Yuyue.vue"),
  },
  {
    path: `/yuyueSucceed`,
    name: "YuyueSucceed",
    meta: {
      title: "预约成功",
      // login: true,
    },
    component: () => import("@/views/YuyueSucceed.vue"),
  },
  {
    path: `/addresses`,
    name: "Addresses",
    meta: {
      title: "地址管理",
      login: true,
    },
    component: () => import("@/views/Addresses.vue"),
  },
  {
    path: `/addaddress`,
    name: "Addaddress",
    meta: {
      title: "填写地址",
      login: true,
    },
    component: () => import("@/views/Addaddress.vue"),
  },
  {
    path: `/information`,
    name: "Information",
    meta: {
      title: "资讯详情",
    },
    component: () => import("@/views/Information.vue"),
  },
  {
    path: `/way`,
    name: "Way",
    meta: {
      title: "处理方式",
    },
    component: () => import("@/views/Way.vue"),
  },
  {
    path: `/welfareRules`,
    name: "WelfareRules",
    meta: {
      title: "活动规则",
    },
    component: () => import("@/views/WelfareRules.vue"),
  },
  {
    path: `/scope`,
    name: "Scope",
    meta: {
      title: "上门范围",
    },
    component: () => import("@/views/Scope.vue"),
  },
  {
    path: `/login`,
    name: "Login",
    meta: {
      title: "登录",
    },
    component: () => import("@/views/Login.vue"),
  },
  {
    path: `/about`,
    name: "About",
    meta: {
      title: "关于我们_白鲸鱼",
    },
    component: () => import("@/views/About.vue"),
  },
  {
    path: `/agreement`,
    name: "Agreement",
    meta: {
      title: "服务协议",
    },
    component: () => import("@/views/Agreement.vue"),
  },
  {
    path: `/policy`,
    name: "Policy",
    meta: {
      title: "隐私政策",
    },
    component: () => import("@/views/Policy.vue"),
  },
  {
    path: `/certificate`,
    name: "Certificate",
    meta: {
      title: "我的证书",
      login: true,
    },
    component: () => import("@/views/Certificate.vue"),
  },
  {
    path: `/poster`,
    name: "Poster",
    meta: {
      title: "海报分享",
      login: true,
    },
    component: () => import("@/views/Poster.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(), //process.env.BASE_URL
  routes,
  // 页面跳转清除原有scroll
  scrollBehavior: () => ({ top: 0 }),
});

// 全局路由守卫;
router.beforeEach((to, from, next) => {
  console.log("to", to);
  console.log("from", from);

  to.fullPath = decodeURIComponent(to.fullPath);
  to.path = decodeURIComponent(to.path);

  if (to.meta.title) {
    // 当title有值的时候，进行赋值动作，
    document.title = to.meta.title;
  } else {
    // title没值，则赋值合作商的页面标题
    document.title = store.state.partnerConfig.basic?.title;
  }

  // 外部页面跳转回来，重新赋值vuex状态
  if (!store.state.appkey && localStorage.getItem("CONFIG")) {
    let data = JSON.parse(localStorage.getItem("CONFIG"));
    store.commit("setAll", data);
    document
      .getElementsByTagName("body")[0]
      .style.setProperty(
        "--themeColor",
        `rgb(${data.partnerConfig.basic.theme_color})`
      ); // 设置主题色
    document
      .getElementsByTagName("body")[0]
      .style.setProperty(
        "--themeBgColor",
        `rgb(${data.partnerConfig.basic.theme_color},0.1)`
      ); // 设置主题背景色
    document.title = data.partnerConfig.basic.title; // 设置页面标题
  }

  // 拦截需要登录页面
  if (from.fullPath != "/login" && to.meta.login && !store.getters.isLogin) {
    next("/login");
    return;
  }

  next();
});

export default router;

export function myRouter() {
  return router;
}
